module.exports = function(media) {
	"use strict";
  media
  .controller('relatedGalleriesController', relatedGalleriesController)
	relatedGalleriesController.$inject = ["API_URL","$http","$rootScope","getDataService","refreshtokenService","alertService","serverError","offlineError"];
  function relatedGalleriesController(API_URL,$http,$rootScope,getDataService,refreshtokenService,alertService,serverError,offlineError) {
    var vmgr = this;
    var state = 'intext-galleries';
    vmgr.limitPosts = 3;
    vmgr.allPosts = [];
    vmgr.selectedCategoryAction = { value:'vesti'};
    vmgr.switchCategoryAction= function(category_id) {
      vmgr.allPosts = [];
      getSharedPosts();
    }
    vmgr.allPostSave = function(categoryName) {
      var posts =[];
      if(vmgr.allPosts.length < vmgr.limitPosts) {
        alertService('danger', 'Opps! ', 'Minimum number of posts is ' +vmgr.limitPosts+'!');
        return
      }
     
      for (var i=0; i<vmgr.allPosts.length;i++) {
        posts.push({'_id':vmgr.allPosts[i]._id, 'order':vmgr.allPosts[i].order, "custom_title":vmgr.allPosts[i].custom_title || "", "gallery_number":vmgr.allPosts[i].gallery_number, "post_id":vmgr.allPosts[i].post_id['_id']});
      }
      $rootScope.hasLoaded = false;
      var updateFunction = function(url) {
        $http.put(url , posts)
        .success(function (data, stat, headers) {
          // $rootScope.hasLoaded = true;
          getSharedPosts()
          alertService('success','Success ', data.message, 2000);
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  updateFunction();
                }
              },
              function(error) {
              },
              function(progress) {
                // report progress
            });
          }else if(status ==502) {
            serverError()  
          } else { 
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        }); 
      }
      updateFunction(API_URL+ state + "/"+vmgr.selectedCategoryAction.value);
    }
    vmgr.removeFromPopularPosts = function(index) {
      vmgr.allPosts.splice(index,1);
    }
    var getSharedPosts = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({param1:state, category:vmgr.selectedCategoryAction.value}).$promise.then(function(data){  
        $rootScope.hasLoaded = true;
        if(data.galleries) {
          vmgr.allPosts = data.galleries;
          for (var i=0; i<vmgr.allPosts.length;i++) {
            if(!vmgr.allPosts[i].max_galleries) {
              vmgr.allPosts[i].max_galleries = 1;
            }
            if(!vmgr.allPosts[i].gallery_number) {
              vmgr.allPosts[i].gallery_number = 1;
            }
            if(parseInt(vmgr.allPosts[i].gallery_number)> parseInt(vmgr.allPosts[i].max_galleries)) {
              vmgr.allPosts[i].gallery_number = vmgr.allPosts[i].max_galleries
            }  
            vmgr.allPosts[i].galleriesArray = (function() {
              return new Array(parseInt(vmgr.allPosts[i].max_galleries));   
          })()
          }
        }
        if(data.categories) {
          vmgr.allCategories = data.categories
        }
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getSharedPosts();
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        } 
        $rootScope.hasLoaded = true;
      });
    }
    getSharedPosts()
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/relatedGalleries/js/relatedGalleriesController.js
// module id = 524
// module chunks = 0